import AppLoader from '@/components/AppLoader';
import RootPagesDetailsSuccess from './components/RootPagesDetailsSuccess';
import { useRootPageDetails } from './rootpage-details.controller';

export default function RootPageDetailsPage() {
	const { query, state, isLoading, handleChange } = useRootPageDetails();

	if (!query.data) {
		return <AppLoader />;
	}

	return (
		<RootPagesDetailsSuccess
			errors={state.errors}
			onChange={handleChange}
			rootPage={query.data}
			isLoading={isLoading}
		/>
	);
}
